import { useQuery } from "react-query";
import { getWarrantyCoverageList } from "../../../../../actions/Utilities/WarrantyCoverage";

export default function useGetWarrantyCoverageList() {
  return useQuery("GetWarrantyCoverage", getWarrantyCoverageList, {
    refetchOnWindowFocus: false,
  });
}
